import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
// import classnames from "classnames";
import axios from "axios";
import Location from "./Location";
import lazyElements from "../lazyElements/lazyElements";
import lazyImages from "../lazyImages/lazyImages";
import loadStylesheet from "../loadStylesheet";
import withActiveCarouselState from "../HOC/withActiveCarouselState";
import Image from '../components/Image';
import CarouselPlaceholder from '../components/CarouselPlaceholder';
import { Helmet } from "react-helmet";
// import ThumbnailGallery from "../location/thumbnailGallery/ThumbnailGallery";
// import Spinner from "../components/Spinner";

class Locations extends Component {
    state = {
        title,
        slug,
        thumb,
        is_category,
        singular_title,
        exclusiveLocations: [],
        featuredLocations: [],
        newLocations: [],
        locations: [],
        page: 0,
        lastPage: null,
    };

    loading = false;
    lazyLoadTrigger = React.createRef();
    intersectObservers = [];
    nonLocationRoutes = [
        'top-categories',
        'all-categories',
    ];
    isNonLocationRoute = this.nonLocationRoutes.includes(this.props.match.params.slug);
    perPage = 5000;

    componentDidMount() {
        this.updateLocations(1, true);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.isNonLocationRoute = this.nonLocationRoutes.includes(this.props.match.params.slug);

        this.intersectObservers.forEach(observer => observer.disconnect());

        if (this.isNonLocationRoute) {
            let images = document.querySelectorAll('.il-non-loc-route-image .lazy-image');

            this.intersectObservers.push(lazyImages(images));
        }
        // if (!!this.lazyLoadTrigger.current)
        //     this.lazyObserver.push(
        //         lazyElements(this.lazyLoadTrigger.current, () => {
        //             this.updateLocations(this.state.page + 1);
        //         })
        //     );

        if (prevProps.match.params.slug !== this.props.match.params.slug) {
            this.updateLocations(1, true);
            window.scrollTo(0, 0);
        }
    }

    updateLocations = (page, dumpPreviousLocations = false) => {
        let endpoint;

        if (!this.loading) {
            this.loading = true;

            if (dumpPreviousLocations) {
                this.setState({
                    locations: [],
                    exclusiveLocations: [],
                    featuredLocations: [],
                    newLocations: [],
                    page: 0,
                });
            }

            if (this.isNonLocationRoute) {
                endpoint = "/api/category/" + this.props.match.params.slug;
            } else {
                endpoint = "/api/category/" + this.props.match.params.slug + "/" + page + "?per_page=";
                endpoint += this.perPage;
            };

            axios.get(endpoint).then(response => {
                if (window.innerWidth >= 767)
                    loadStylesheet();

                this.loading = false;

                this.setState(state => {
                    let locations = [];
                    let exclusiveLocations = [];
                    let featuredLocations = [];
                    let newLocations = [];

                    if (dumpPreviousLocations) {
                        if (this.isNonLocationRoute) {
                            locations = response.data.categories;
                        } else {
                            locations = response.data.paginator?.data || [];
                            exclusiveLocations = response.data?.exclusives || [];
                            featuredLocations = response.data?.featured || [];
                            newLocations = response.data?.new_locations || [];
                        }
                    } else {
                        locations = state.locations.concat(response.data.paginator.data);
                    }

                    return {
                        title: !!response.data.title ? response.data.title : null,
                        slug: !!response.data.slug ? response.data.slug : null,
                        thum: !!response.data.thumb ? response.data.thumb : null,
                        singular_title: !!response.data.singular_title ? response.data.singular_title : '',
                        locations,
                        exclusiveLocations,
                        featuredLocations,
                        newLocations: newLocations,
                        page: !!response.data.paginator ? response.data.paginator.current_page : null,
                        lastPage: !!response.data.paginator ? response.data.paginator.last_page : null,
                    };
                });

            }).catch(function (error) {
                console.log(error);
            });
        };
    }

    render() {
        let placeHolders = [];
        for (let i = 0; i < 8; i++) {
            placeHolders.push(
                <li key={i} className="col-sm-6 col-lg-4 col-xl-3 px-2 mb-3 il-no-banners il-xs-carousel-container d-flex flex-wrap align-items-end">
                    <h5 className="h5 mb-0 w-100 mt-2 pr-md-5">
                        <span className="d-inline-block bg-light w-75">&nbsp;</span>
                    </h5>
                    {!this.isNonLocationRoute && (
                        <p className="location-city ellipse-overflow small mb-2 w-100">
                            <span className="d-inline-block bg-light w-25">&nbsp;</span>
                        </p>
                    )}

                    <div className="w-100 position-relative order-first il-location-carousel il-carousel has-scrollbar">
                        <div className="il-pre-carousel-thumb"></div>
                        {!this.isNonLocationRoute && (
                            <div className="swiper-scrollbar"></div>
                        )}
                    </div>
                </li>
            );
        }

        let title = null;
        let description = null;
        let url = site_url + "/location-library/" + this.state.slug;

        if (this.state.singular_title) {
            title = `Browse ${this.state.singular_title} Photo Shoot & Filming Locations | Location Library | ${site_name}`;
        } else {
            title = `Browse ${this.state.title} | Location Library | ${site_name}`;
        }

        if (this.state.slug === 'all-categories')
            description = 'View all our available location categories.';
        if (this.state.slug === 'top-categories')
            description = 'View our most popular location categories.';
        if (!description)
            description = `Search ${this.state.singular_title} locations for your next filming or prography project.`;

        return (
            <Fragment>
                <Helmet>
                    <title>{title}</title>
                    <meta name="description" content={description} />
                    <link rel="canonical" href={url} />
                    <meta property="og:title" content={title} />
                    <meta property="og:description" content={description} />
                    <meta property="og:url" content={url} />
                    <meta property="og:image" content={thumb} />
                    <meta name="twitter:title" content={title} />
                    <meta name="twitter:description" content={description} />
                </Helmet>

                {/* Wrapper div that contains both sections */}

                <div>
                    <div className="exclusive-section">
                        {!this.isNonLocationRoute && !!this.state.exclusiveLocations.length && (
                            <>
                                <div className="sticky-top bg-white w-100">
                                    <p className="h6 text-white d-block my-2 px-2 py-2 font-weight-bold" style={{ background: "#484848" }}>Exclusive {this.state.singular_title} Locations</p>
                                </div>
                                <div>
                                    <ul className="d-flex flex-wrap mx-n2 list-unstyled align-items-stretch">
                                        {this.state.exclusiveLocations.map((exclusiveLocation, key) => (
                                            <Location
                                                {...exclusiveLocation}
                                                categorySlug={this.props.match.params.slug}
                                                smallScreen={this.props.smallScreen}
                                                size="xs"
                                                setThumbGalleryActive={this.props.setThumbGalleryActive}
                                                isActive={this.props.activeLocations.includes(exclusiveLocation.id)}
                                                onActiveCallback={this.props.onActiveCallback}
                                                key={key}
                                                className="col-sm-6 col-lg-4 col-xl-3 px-2 il-no-banners"
                                            />
                                        ))}
                                    </ul>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Featured section - hide for exclusives category */}
                    <div className="featured-section">
                        {!this.isNonLocationRoute && !!this.state.featuredLocations.length && this.props.match.params.slug !== 'exclusives' && (
                            <>
                                <div className="sticky-top bg-white w-100">
                                    <p className="h6 text-white d-block my-2 px-2 py-2 font-weight-bold" style={{ background: "#484848" }}>Featured {this.state.singular_title} Locations</p>
                                </div>
                                <div>
                                    <ul className="d-flex flex-wrap mx-n2 list-unstyled align-items-stretch">
                                        {this.state.featuredLocations.map((featuredLocation, key) => (
                                            <Location
                                                {...featuredLocation}
                                                categorySlug={this.props.match.params.slug}
                                                smallScreen={this.props.smallScreen}
                                                size="xs"
                                                setThumbGalleryActive={this.props.setThumbGalleryActive}
                                                isActive={this.props.activeLocations.includes(featuredLocation.id)}
                                                onActiveCallback={this.props.onActiveCallback}
                                                key={key}
                                                className="col-sm-6 col-lg-4 col-xl-3 px-2 il-no-banners"
                                            />
                                        ))}
                                    </ul>
                                </div>
                            </>
                        )}
                    </div>

                    {/* New Locations section - hide for exclusives category */}
                    <div className="new-section"> {/* This will push the sticky header up when scrolled to */}
                        {!this.isNonLocationRoute && !!this.state.newLocations.length && this.props.match.params.slug !== 'exclusives' && (
                            <>
                                <div className="sticky-top bg-white w-100">
                                    <p className="h6 text-white d-block my-2 px-2 py-2 font-weight-bold" style={{ background: "#484848" }}>New {this.state.singular_title} Locations</p>
                                </div>
                                <ul className="d-flex flex-wrap mx-n2 list-unstyled align-items-stretch">
                                    {this.state.newLocations.map((newLocation, key) => (
                                        <Location
                                            {...newLocation}
                                            categorySlug={this.props.match.params.slug}
                                            smallScreen={this.props.smallScreen}
                                            size="xs"
                                            setThumbGalleryActive={this.props.setThumbGalleryActive}
                                            isActive={this.props.activeLocations.includes(newLocation.id)}
                                            onActiveCallback={this.props.onActiveCallback}
                                            key={key}
                                            className="col-sm-6 col-lg-4 col-xl-3 px-2 il-no-banners"
                                        />
                                    ))}
                                </ul>
                            </>
                        )}
                    </div>
                </div>


                <div className="locations">
                    <div className="sticky-top bg-white w-100">
                        <p className="h6 text-white d-block my-2 px-2 py-2 font-weight-bold" style={{ background: "#484848" }}>All {this.state.singular_title} Locations</p>
                    </div>

                    <ul className="d-flex flex-wrap mx-n2 list-unstyled align-items-stretch">
                        {!this.isNonLocationRoute && !!this.state.locations && this.state.locations.map((location, key) => (
                            <Location
                                {...location}
                                categorySlug={this.props.match.params.slug}
                                smallScreen={this.props.smallScreen}
                                size="xs"
                                setThumbGalleryActive={this.props.setThumbGalleryActive}
                                isActive={this.props.activeLocations.includes(location.id)}
                                onActiveCallback={this.props.onActiveCallback}
                                key={key}
                                className="col-sm-6 col-lg-4 col-xl-3 px-2 il-no-banners"
                            />
                        ))}

                        {this.isNonLocationRoute && !!this.state.locations && this.state.locations.map((category, key) => (
                            <li
                                key={key}
                                className="col-sm-6 col-lg-4 col-xl-3 px-2 il-no-banners il-xs-carousel-container d-flex flex-wrap align-items-end mb-3"
                            >
                                <h5 className="h5 mb-0 w-100 mt-2 pr-md-5">
                                    <Link
                                        to={category.slug}
                                        className="text-dark font-weight-light text-decoration-none"
                                    >{category.title}</Link>
                                </h5>
                                <Link
                                    to={category.slug}
                                    className="il-non-loc-route-image w-100 il-location-carousel il-carousel has-scrollbar position-relative order-first">
                                    {!!category.thumbnail && (
                                        <CarouselPlaceholder
                                            loadedThumbnail={false}
                                            title={category.title}
                                            img={category.thumbnail}
                                        />
                                    )}
                                </Link>
                            </li>
                        ))}

                        {this.state.page == 0 && (
                            placeHolders
                        )}

                    </ul>
                </div>

                {/* {this.state.page !== this.state.lastPage && (
                    <div className="d-flex justify-content-center my-5">
                        <div
                            ref={!!this.state.locations.length ? this.lazyLoadTrigger : null}
                            className="spinner-grow text-secondary mb-5"
                            role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                )} */}
            </Fragment>
        );
    }
}

export default withActiveCarouselState(Locations);
